<template>
  <nuxt-link :to="toPathTrailed" :class="classNames">
    <slot></slot>
  </nuxt-link>
</template>

<script>
  /* This component shared automatically.
   * No need to import it any time
   */
  export default {
    props: {
      to: { type: String, default: '' },
    },
    computed: {
      toPathTrailed() {
        if (this.to === '/' || !this.to) return this.to;
        return this.to.replace(/\/$/, "");
      },
      classNames() {
        let classNames = ['link'];
        if ($nuxt.$route.path === this.toPathTrailed) {
          classNames.push('path-exact');
        }
        if (this.to !== '/' && $nuxt.$route.path.indexOf(this.toPathTrailed) !== -1) {
          classNames.push('path-exist');
        }
        return classNames;
      }
    },
  }
</script>



// WEBPACK FOOTER //
// components/shared/_any/LinkTo.vue